/*
 * @Author: your name
 * @Date: 2022-02-09 10:34:15
 * @LastEditTime: 2022-03-03 22:48:20
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\store\index.js
 */
// index.ts  
import Vue from 'vue';  
import Vuex from 'vuex';  
import appFactory from './modules/app'
import userFactory from './modules/user'
import dictionaryFactory from './modules/dictionary'
import gettersFactory from './getters'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex);  

/**
 * 业务复杂后，可实现模块化管理
 */
const store = new Vuex.Store({  
  modules: {
    app: appFactory,
    user: userFactory,
    dictionary: dictionaryFactory
  },
  getters: gettersFactory,
  plugins: [createPersistedState()]
});  


export default store